import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges Tailwind CSS class names, resolving conflicts intelligently.
 * Use this for all conditional class composition in components.
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-brand text-brand-text', className)
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
